(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wm-card-media"] && !Shopify.designMode) return;
  try {
    if ('customElements' in window && !customElements.get('wm-card-media')) {
  customElements.define('wm-card-media', class extends HTMLElement {
    connectedCallback() {
      if (this.wmInitialized) return;
      this.wmInitialized = true;
      const room = this.querySelector('.wm-card-media__image--room');
      if (!room) return;
      const ready = () => {
        this.classList.toggle('is-room-ready', room.complete && room.naturalWidth > 0);
      };
      room.addEventListener('load', ready);
      room.addEventListener('error', () => this.classList.remove('is-room-ready'));
      ready();
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
